import { useState, useEffect, useRef } from "react";
import {
  NAVBAR_SCROLL_THRESHOLD,
  NAVBAR_FADED_OPACITY,
  NAVBAR_FULL_OPACITY,
} from "./constants";

export function useNavbarScroll(enabled = true) {
  const [navOpacity, setNavOpacity] = useState(NAVBAR_FULL_OPACITY);
  const lastScrollY = useRef(0);

  useEffect(() => {
    if (!enabled) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (prefersReducedMotion) return;

    function handleScroll() {
      const currentScrollY = window.scrollY;
      const isScrollingDown = currentScrollY > lastScrollY.current;
      const isPastThreshold = currentScrollY > NAVBAR_SCROLL_THRESHOLD;

      setNavOpacity(
        isScrollingDown && isPastThreshold
          ? NAVBAR_FADED_OPACITY
          : NAVBAR_FULL_OPACITY,
      );

      lastScrollY.current = currentScrollY;
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [enabled]);

  return { navOpacity: enabled ? navOpacity : NAVBAR_FULL_OPACITY };
}
